import { normalizeLocaleCode, shortenLocaleCode } from './locale-matcher';
import { BRAZILIAN_PORTUGUESE } from './supported-locales';
import type { Locale } from './types';

export interface VisitorKiosk {
  privacy_policy_variant?: string | null;
}

export function browserLanguages(): string[] {
  const { language, languages } = navigator;
  return (languages?.length ? [...languages] : [language]).filter(Boolean);
}

// The first Portuguese entry decides, so `['pt-PT', 'pt-BR']` stays European.
function prefersBrazilianPortuguese(languages: readonly string[]): boolean {
  const portuguese = languages
    .map(normalizeLocaleCode)
    .find(({ lang }) => lang === 'pt');
  return portuguese?.country === 'BR';
}

// Kiosk config has no country field; the Brazilian privacy policy is the one
// marker a Brazilian kiosk carries.
function isBrazilianKiosk(kiosk: VisitorKiosk | null | undefined): boolean {
  return kiosk?.privacy_policy_variant === 'br_policy';
}

export function localesForVisitor(
  locales: readonly Locale[],
  languages: readonly string[],
  kiosk: VisitorKiosk | null | undefined
): Locale[] {
  if (!(prefersBrazilianPortuguese(languages) || isBrazilianKiosk(kiosk))) {
    return [...locales];
  }
  return locales.map((locale) =>
    shortenLocaleCode(locale.code) === 'pt' ? BRAZILIAN_PORTUGUESE : locale
  );
}
